const mapLineItemVariant = variant => {
  return { title: variant.title }
}

const mapLineItem = item => {
  return {
    id: item.id,
    name: item.name,
    sku: item.sku,
    price: item.price,
    image: item.image,
    status: item.status,
    shipment_id: item.shipment_id,
    return_id: item.return_id,
    requires_shipping: item.requires_shipping,
    variant: item.variant ? mapLineItemVariant(item.variant) : item.variant,
    product: { url: item.product.url },
  }
}

const mapLastUpdate = lastUpdate => {
  return { substatus: lastUpdate.substatus, timestamp: lastUpdate.timestamp, is_alert: lastUpdate.is_alert }
}

const mapTrackingLabel = label => {
  return {
    id: label.id,
    status: label.status,
    shipped_at: label.shipped_at,
    delivered_at: label.delivered_at,
    eta: label.eta,
    last_update: label.last_update ? mapLastUpdate(label.last_update) : label.last_update,
  }
}

const mapReturnRequest = returnRequest => {
  return {
    id: returnRequest.id,
    requested_at: returnRequest.requested_at,
    refund_status: returnRequest.refund_status,
    refund_amount: returnRequest.refund_amount,
    payment_status: returnRequest.payment_status,
    payment_amount: returnRequest.payment_amount,
    currency: returnRequest.currency,
  }
}

export const transformResponseOrderTrackingPreviewOrder = order => {
  return {
    id: order.id,
    name: order.name,
    number: order.number,
    external_created: order.external_created,
    alert: order.alert,
    status: { value: order.status.value },
    customer: { email: order.customer.email },
    line_items: order.line_items.map(mapLineItem),
    shipping_labels: order.shipping_labels.map(mapTrackingLabel),
    return_labels: order.return_labels.map(mapTrackingLabel),
    return_requests: order.return_requests.map(mapReturnRequest),
    matching_visibility_criterion_ids: order.matching_visibility_criterion_ids,
  }
}
